<template>
  <span :class="[`pill-${variant}`, `pill-${size}`]">
    <slot></slot>
  </span>
</template>
<script lang="ts">
export enum PillVariant {
  EXCEPTION = 'exception',
  ATTENTION = 'attention',
  INFO_PRIMARY = 'info-primary',
  INFO_SECONDARY = 'info-secondary',
  INFO_TERTIARY = 'info-tertiary',
  SUCCESS = 'success',
  PREVIEW = 'preview'
}
</script>
<script setup lang="ts">
export type PillProps = {
  variant?: PillVariant;
  size?: 'sm' | 'md' | 'lg';
};
const { variant = PillVariant.INFO_SECONDARY, size = 'md' } =
  defineProps<PillProps>();
</script>
<style lang="scss" scoped>
[class|='pill'] {
  border-radius: $border-radius-lg;
  display: flex;
  align-items: center;
}

.pill-exception {
  background-color: $red-24;
  color: $gray-78;
}
.pill-attention {
  background-color: $yellow-23;
  color: $gray-78;
}
.pill-info-secondary {
  background-color: $gray-28;
  color: $gray-78;
}
.pill-info-tertiary {
  background-color: $purple;
  color: $gray-78;
}
.pill-info-primary {
  background-color: $white;
  color: $brand-blue;
  border: 1px solid $brand-blue;
}
.pill-preview {
  background-color: $white;
  color: $gray-78;
  border: 1px solid $gray-28;
}

.pill-success {
  background-color: $green-14;
  color: $green-44;
  border: 1px solid $green-34;
}

.pill-sm {
  font-size: $font-size-3xs;
  padding: $spacing-4xs $spacing-3xs;
}
.pill-md {
  font-size: $font-size-2xs;
  padding: $spacing-4xs $spacing-2xs;
}
.pill-lg {
  font-size: $font-size-xs;
  padding: $spacing-4xs $spacing-xs;
}
</style>
